// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1ifR1","validationTips":"StatementDescriptor_validationTips__3dzth"};